export enum ProcessMapState {
  StartingPoint,
  ProcessList,
  NewProcess,
  ProcessDetails,
}
